<template>
  <div class="legal-container">
    <h1>DRAFT</h1>
    <h1>Terms of Service</h1>
    <p>Last Updated: February 23, 2026</p>

      <h4>1. Acceptance of Terms</h4>
      <p>By accessing or using AppWafn (the "Platform"), you agree to be bound by these Terms of Service. AppWafn is a sovereign digital space managed by [Your Registered Business Name], based in Ontario, Canada.</p>

      <h4>2. The Platform as a Facilitator</h4>
      <p>AppWafn provides a marketplace and subscription service. You acknowledge that AppWafn is a facilitator of user-to-user transactions. We do not own, sell, or take responsibility for the items or services exchanged between users in the marketplace.</p>

      <h4>3. Subscriptions and 30-Day Trial</h4>
      <ul>
        <li><strong>Trial Period:</strong> New users are eligible for a 30-day free trial. A valid credit card is required to initiate the trial.</li>
        <li><strong>Billing:</strong> After 30 days, your card will be automatically charged the recurring subscription fee via Helcim.</li>
        <li><strong>Cancellation:</strong> You may cancel your subscription at any time through your account settings. If you cancel during the trial, you will not be charged.</li>
      </ul>

      <h4>4. Payments and Fees</h4>
      <p>Payments are processed securely through Helcim, a Canadian payment gateway. You agree to provide accurate payment information. AppWafn may collect a platform fee on marketplace transactions, which will be disclosed at the time of purchase.</p>
      <p>Payment data is tokenized and processed via Helcim's PCI-compliant vault. AppWafn does not store full credit card numbers on its servers.</p>

      <h4>5. Prohibited Conduct</h4>
      <p>Users may not use the platform for:</p>
      <ul>
        <li>Illegal activities or the sale of prohibited goods.</li>
        <li>Infringing on the intellectual property of others.</li>
        <li>Attempting to bypass platform security or harvest user data.</li>
      </ul>

      <h4>6. Limitation of Liability</h4>
      <p>To the maximum extent permitted by Ontario law, AppWafn shall not be liable for any indirect, incidental, or consequential damages resulting from your use of the platform or transactions made between users. AppWafn is not responsible for data loss or server downtime within reasonable limits.</p>

      <h4>7. Governing Law</h4>
      <p>These terms are governed by the laws of the Province of Ontario and the federal laws of Canada.</p>

      <h4>8. Refund & Cancellation Policy</h4>
      <p><strong>Subscriptions:</strong> All subscriptions can be cancelled at any time. We do not offer pro-rated refunds for partial months, but you will retain access until the end of your current billing period.</p>
      <p><strong>Marketplace:</strong> Refunds for items purchased from other users must be negotiated directly between the buyer and seller. AppWafn does not handle marketplace refunds.</p>

      <h4>Contact Us</h4>
      <p>If you have any questions about these Terms, please contact AppWafn Support at support@appwafn.ca.</p>
  </div>
</template>

<script>
export default {
  name: 'TermsView'
}
</script>

<style scoped>

.legal-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  line-height: 1.6;
  color: #333;
  text-align: left;
}

h1 {
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
}

h4 {
  margin-top: 25px;
  margin-bottom: 10px;
  color: #2c3e50;
}

ul {
  padding-left: 20px;
  margin-bottom: 15px;
}

p {
  margin-bottom: 15px;
}
</style>
